<template>
	<div>
		
		<div class="user-information__title">User Information</div>
		
		
		<div class="user-information">
			
			<div class="user-information__detail">
				<div class="user-information__label">Nickname</div>
				<div class="user-information__value">{{ userStore.user.nick_name }}</div>
			</div>


			<div class="user-information__detail">
				<div class="user-information__label">User ID</div>
				<div class="user-information__value">#{{ userStore.user.id }}</div>
			</div>


			<div class="user-information__detail">
				<div class="user-information__label">Phone Number</div>
				<div class="user-information__value"
					:class="{ 'user-information__value--clickable': !userStore.user.phone_number }"
					@click="handlePhoneNumberClick">
					{{ userPhoneNumber }}
				</div>
			</div>


			<div class="user-information__detail">
				<div class="user-information__label">Member Since</div>
				<div class="user-information__value">{{ formattedDate }}</div>
			</div>


			<div class="user-information__detail user-information__detail--country">
				<div class="user-information__label">Country</div>
				<div class="user-information__value user-information__value--with-flag">
					<span class="user-information__flag">
						<country-flag :country="userStore.user.country" />
					</span>
					<span>{{ userCountry }}</span>
				</div>
			</div>

		</div>
	</div>
</template>



<script setup lang="ts">

import { computed } from 'vue';
import { useRouter } from 'vue-router';
import { useUserStore } from "../../store/UserStore";
import CountryFlag from "vue-country-flag-next";
import { PayoutStore } from "@/store/PayoutStore";
import { formatDate, formatPhoneNumber } from '@/utils/utils';

const router = useRouter();
const userStore = useUserStore();
const payoutStore = PayoutStore();

const payoutOptionCountries = computed(() => payoutStore.PayoutOptionCountries);

const getCountryName = (regionCode: string) => {
	const country = payoutOptionCountries.value.find(c => c.region_code === regionCode);
	return country ? country.region_name : regionCode;
}

const userCountry = computed(() => {
	const userCountryCode = userStore.user?.country;
	return userCountryCode ? getCountryName(userCountryCode) : '';
});

const userPhoneNumber = computed(() => {
	return userStore.user.phone_number ? formatPhoneNumber(userStore.user.phone_number) : 'Not Provided';
});

const formattedDate = computed(() => formatDate(userStore.user.created_at));

const handlePhoneNumberClick = () => {
	if (!userStore.user.phone_number) {
		router.push('/edit-profile')
	}
}

</script>